module.exports = __webpack_public_path__ + "static/architecture-10e0708ba933657e932cfae4a464d9bc.svg";